import { ImageUrlsResized } from "./models/images.model";

export const ILS_CONTACT_EMAIL = "info@ilovesport.hu";
export const ILS_FACEBOOK = "https://www.facebook.com/ilovesporthu";
export const ILS_YOUTUBE = "https://www.youtube.com/user/ilovesporthu";
export const ILS_SITE_NAME = "ilovesport.hu";
export const ILS_COPYRIGHT_YEAR = "2015";

export const ILS_SOCIAL_SITE_URL = "http://www.ilovesport.hu";
export const ILS_SOCIAL_DESCRIPTION = "";
export const ILS_SOCIAL_HASHTAG = "ILoveSport";
export const DEFAULT_CURRENCY = "Ft";

export const DEFAULT_SWIPER_BACKGROUNDS: ImageUrlsResized[] = [
  {
    s: require("@/assets/images/backgrounds/s/album4-image-2.jpg"),
    m: require("@/assets/images/backgrounds/m/album4-image-2.jpg"),
    l: require("@/assets/images/backgrounds/l/album4-image-2.jpg"),
    xl: require("@/assets/images/backgrounds/xl/album4-image-2.jpg")
  },
  {
    s: require("@/assets/images/backgrounds/s/album6-image-2.jpg"),
    m: require("@/assets/images/backgrounds/m/album6-image-2.jpg"),
    l: require("@/assets/images/backgrounds/l/album6-image-2.jpg"),
    xl: require("@/assets/images/backgrounds/xl/album6-image-2.jpg")
  },
  {
    s: require("@/assets/images/backgrounds/s/album1-image-1.jpg"),
    m: require("@/assets/images/backgrounds/m/album1-image-1.jpg"),
    l: require("@/assets/images/backgrounds/l/album1-image-1.jpg"),
    xl: require("@/assets/images/backgrounds/xl/album1-image-1.jpg")
  },
  {
    s: require("@/assets/images/backgrounds/s/gallery-image-1.jpg"),
    m: require("@/assets/images/backgrounds/m/gallery-image-1.jpg"),
    l: require("@/assets/images/backgrounds/l/gallery-image-1.jpg"),
    xl: require("@/assets/images/backgrounds/xl/gallery-image-1.jpg")
  },
  {
    s: require("@/assets/images/backgrounds/s/gallery-image-3.jpg"),
    m: require("@/assets/images/backgrounds/m/gallery-image-3.jpg"),
    l: require("@/assets/images/backgrounds/l/gallery-image-3.jpg"),
    xl: require("@/assets/images/backgrounds/xl/gallery-image-3.jpg")
  },
  {
    s: require("@/assets/images/backgrounds/s/bg-image-1.jpg"),
    m: require("@/assets/images/backgrounds/m/bg-image-1.jpg"),
    l: require("@/assets/images/backgrounds/l/bg-image-1.jpg"),
    xl: require("@/assets/images/backgrounds/xl/bg-image-1.jpg")
  },
  {
    s: require("@/assets/images/backgrounds/s/event_placeholder.jpg"),
    m: require("@/assets/images/backgrounds/m/event_placeholder.jpg"),
    l: require("@/assets/images/backgrounds/l/event_placeholder.jpg"),
    xl: require("@/assets/images/backgrounds/xl/event_placeholder.jpg")
  }
];

export const PAGINATION_FIRST_PAGE = 1;
